var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    [
      _vm.showItemLabel
        ? [
            _vm.clickable
              ? _c(
                  "a",
                  {
                    staticClass: "label",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$emit("edit", _vm.item)
                      }
                    }
                  },
                  [
                    _c("LabelContent", {
                      attrs: {
                        item: _vm.item,
                        "label-type": _vm.labelType,
                        "is-last-level": _vm.isLastLevel,
                        "has-selected-childs-to-last-level":
                          _vm.hasSelectedChildsToLastLevel,
                        "has-icon": _vm.hasIcon,
                        "icon-path": _vm.iconPath,
                        level: _vm.level,
                        "no-children-appendix": _vm.noChildrenAppendix,
                        "label-appendix": _vm.labelAppendix
                      }
                    })
                  ],
                  1
                )
              : _c(
                  "span",
                  { staticClass: "label" },
                  [
                    _c("LabelContent", {
                      attrs: {
                        item: _vm.item,
                        "label-type": _vm.labelType,
                        "is-last-level": _vm.isLastLevel,
                        "has-selected-childs-to-last-level":
                          _vm.hasSelectedChildsToLastLevel,
                        "has-icon": _vm.hasIcon,
                        "icon-path": _vm.iconPath,
                        level: _vm.level,
                        "no-children-appendix": _vm.noChildrenAppendix,
                        "label-appendix": _vm.labelAppendix
                      }
                    })
                  ],
                  1
                )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showAdditions && _vm.hasAdditions
        ? _c("Additions", {
            attrs: {
              "is-list-styling": _vm.isListStyling,
              list: _vm.list,
              experience: _vm.experience,
              "self-assessment": _vm.selfAssessment,
              supplements: _vm.supplements,
              "with-edit-button": _vm.withEditButton,
              deletable: _vm.deletable,
              specificities: _vm.specificities
            },
            on: {
              edit: function($event) {
                return _vm.$emit("edit", _vm.item)
              },
              delete: function($event) {
                return _vm.$emit("delete", _vm.item)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.childs.length > 0
        ? _c(
            "ul",
            {
              class: [
                "characteristic-selected-items",
                "level-" + (_vm.level + 1)
              ]
            },
            _vm._l(_vm.childs, function(item) {
              return _c("characteristic-selected-items-item", {
                key: item.item.id,
                attrs: {
                  item: item,
                  selected: _vm.selected,
                  "show-experience": _vm.showExperience,
                  "show-additions": _vm.showAdditions,
                  "specificities-provider": _vm.specificitiesProvider,
                  deletable: _vm.deletable,
                  "with-edit-button": _vm.withEditButton,
                  level: _vm.level + 1,
                  "no-children-appendix": _vm.noChildrenAppendix,
                  "label-appendix-provider": _vm.labelAppendixProvider,
                  "label-type": _vm.labelType,
                  clickable: _vm.clickable
                },
                on: {
                  edit: function($event) {
                    return _vm.$emit("edit", $event)
                  },
                  delete: function($event) {
                    return _vm.$emit("delete", $event)
                  }
                }
              })
            }),
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }